import { Helper } from "../../core/util/helper";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { AppHelper } from "../../appHelper";
import { AppBaseProps, CommonApp, Context, Entity } from "../../core/components/commonApp";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { EventType } from "../../../siteManagement/eventManager";
import { General } from "../../../siteManagement/general";
import React from "react"
export default class EditMainGroup extends React.Component<EditMainGroupProps, any>{
    common = new AppHelper();
    allowTravelDistanceActive: boolean;
    private _translations: {};

    constructor(props: EditMainGroupProps) {
        super(props);
        this.allowTravelDistanceActive = this.props.allowTravelDistanceActive;
        this._translations = this._getMetaData("translations");
        this.common.init(this);
        this.props.context.translationsGridOptions = this._getMetaData("translationsGridOptions");
        this.props.context.languagesManagementGridOptions = this._getMetaData("languagesManagementGridOptions");
        this.props.context.translations = this._translations;
        this._setEvents();
    }

    private _getMetaData = (name: string) => {
        const objects = this.props.metadata.additional.objects;
        for (let i = 0; i < objects.length; i++) {
            if (objects[i].name == name) {
                return objects[i].data;
            }
        }
    }

    private _checkEntity = () => {
        if (!Helper.isNullOrEmpty(this.props.entity.Name)) {
            return true;
        } else {
            for (let i = 0; i < this.props.entity.LanguageDependentParameters.length; i++) {
                if (Helper.hasValue(this.props.entity.LanguageDependentParameters[i].Name)) {
                    return true;
                }
            }
            return false;
        }
    }

    save = (closeAfterSave) => {
        if (this._checkEntity()) {
            if (this.common.validate()) {
                $(window).trigger("SaveLangugesByMainGroup", { update: true });
                HTTPService.post<JsonResultClass>("MainGroup/SaveMainGroup", this.props.entity)
                    .then(result => {
                        if (result.Code === 0) {
                            this.props.entity.IsNew = false;
                            NotificationHelper.showSuccessMessage(result.Message);
                        } else {
                            NotificationHelper.showErrorMessage(result.Message);
                        }
                        if(this.props.entity.SkillMainGroupDependence)
                            var resultSave=   HTTPService.post<JsonResultClass>('Skills/SaveSkillKatForMainGroup', { bids: this.props.entity.Bids, ogrnr: this.props.entity.OGrNr });
                        General.Events.trigger(EventType.Custom, { cmd: "reloadTravelUnits" });
                        this.common.handlePostSave(result.Code === 0, closeAfterSave);
                        this.setState({});
                    });
            } 
        } else {
            NotificationHelper.showErrorMessage(this._translations["WebSMS.UserSettings.MainGroup.FillAllLanguages"]);
        }
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        if (!isInit) {
            this.common.handleFieldChange(field, value, dataItem);
        }
    }

    private _setEvents = () => {
        $(window).on("MainGroupEntityChanged", (e, d) => {
            if (d.update) {
                this.common.setEntityDirtyState(true);
            }

        });
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
}

export interface EditMainGroupProps extends AppBaseProps {
    entity: MainGroupEntity;
    context: MainGroupContext;
    allowTravelDistanceActive: boolean;
}

interface MainGroupContext extends Context {
    translationsGridOptions?: {};
    languagesManagementGridOptions?: {};
    translations?: {};
}


export interface MainGroupEntity extends Entity{
    OGrNr: number;
    Name: string;
    Description: string;
    CalenderID?: number; 
    TZId?: number;
    IsoCode: string;
    LanguageDependentParameters: MainGroupLanguageDependentParameters[];
    SkillMainGroupDependence: boolean;
    Bids:number[];
    IdCurr?: number;
    IdBaraus?: number;
}

export interface MainGroupLanguageDependentParameters {
    Name: string;
    Description: string;
    Language: LanguageIdx;
}

export interface LanguageIdx {
    Id: number;
    LanguageName: string;
}